module.exports = __webpack_public_path__ + "static/img/5228_phase_function_Paper_Points.3b47101.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5228_phase_function_Paper_Points.png
// module id = SA14
// module chunks = 0